import * as icons from '../../packages/icons/src';

/**
 * Expose @lifterlms/icons via the global `window.llms` object.
 *
 * @since 6.0.0
 */
window.llms = window.llms || {};
window.llms.icons = icons;
